import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import classes from './tenant-maintenance-page.module.scss';

export const TenantMaintenancePage: React.FC = () => {
  return (
    <main className={classes.page} dir="rtl">
      <section className={classes.content} aria-labelledby="maintenance-title">
        <FontAwesomeIcon icon={faScrewdriverWrench as IconProp} className={classes.icon} aria-hidden="true" />
        <h1 id="maintenance-title">עבודות תחזוקה</h1>
        <p>נחזור בקרוב</p>
        <p className={classes.contact}>במקרים חריגים נא לפנות ל - 054-605-7979</p>
      </section>
    </main>
  );
};
